import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { blue500 } from 'material-ui/styles/colors';
import { avatar } from 'src/models/User';
import { Card, CardHeader } from 'material-ui';
import UserApi from 'src/services/UserApi';
var styles = {
    gameContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    cardSlot: {
        margin: '1.25rem'
    },
    cardFace: {
        padding: '1rem',
    },
    cardCover: {
        padding: '1rem',
        backgroundColor: blue500,
    },
    cardCoverTitle: {
        color: '#fff',
        textAlign: 'center'
    }
};
function MemoryCardCover() {
    return (React.createElement(Card, { style: styles.cardCover },
        React.createElement(CardHeader, { title: "Boardy", titleStyle: styles.cardCoverTitle })));
}
function MemoryCardFace(props) {
    return (React.createElement(Card, { style: styles.cardFace },
        React.createElement(CardHeader, { avatar: avatar(Math.abs(props.card.id)) })));
}
function MemoryCardRevealed(props) {
    return (React.createElement(Card, { style: tslib_1.__assign({}, styles.cardFace, { opacity: .5 }) },
        React.createElement(CardHeader, { avatar: avatar(Math.abs(props.card.id)) })));
}
function MemoryCardSlot(props) {
    var card = props.card, revealedCards = props.revealedCards, selectedCards = props.selectedCards, onSelect = props.onSelect;
    var isRevealed = revealedCards.some(function (i) { return i.id === card.id; });
    if (isRevealed) {
        return React.createElement(MemoryCardRevealed, { card: card });
    }
    var isSelected = selectedCards.some(function (i) { return i.id === card.id; });
    var cardElement = isSelected ? React.createElement(MemoryCardFace, { card: card }) : React.createElement(MemoryCardCover, null);
    return (React.createElement("div", { key: card.id, onClick: function (e) { return onSelect(card); }, style: styles.cardSlot }, cardElement));
}
function shuffle(array) {
    var _a;
    var result = array.slice();
    for (var i = result.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        _a = [result[j], result[i]], result[i] = _a[0], result[j] = _a[1];
    }
    return result;
}
var BoardyMemoryGame = /** @class */ (function (_super) {
    tslib_1.__extends(BoardyMemoryGame, _super);
    function BoardyMemoryGame(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            gameEnded: false,
            cards: [],
            selectedCards: [],
            revealedCards: [],
            score: 0
        };
        _this.handleCardSelection = function (card) {
            var selectedCards = _this.state.selectedCards;
            if (selectedCards.length < 2) {
                _this.setState({ selectedCards: selectedCards.concat([card]) }, _this.evaluteSelection);
            }
        };
        _this.evaluteSelection = function () {
            var selectedCards = _this.state.selectedCards;
            var selectionComplete = selectedCards.length === 2;
            var selectionMatch = (selectionComplete &&
                (selectedCards[0].id === -selectedCards[1].id || -selectedCards[0].id === selectedCards[1].id));
            if (selectionComplete) {
                _this.setState({ selectedCards: [] }, _this.evaluateGame);
            }
            if (selectionMatch) {
                _this.setState(function (state) { return ({ revealedCards: state.revealedCards.concat(selectedCards) }); }, _this.evaluateGame);
            }
        };
        _this.evaluateGame = function () {
            var _a = _this.state, cards = _a.cards, revealedCards = _a.revealedCards;
            if (revealedCards.length === cards.length) {
                _this.setState({ gameEnded: true });
            }
        };
        return _this;
    }
    BoardyMemoryGame.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var users, userPairs, deck;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UserApi.getUsers(this.props.userStore.userId)];
                    case 1:
                        users = (_a.sent()).filter(function (i) { return i.hasAvatar; });
                        userPairs = users.map(function (i) { return (tslib_1.__assign({}, i, { id: -i.id })); });
                        deck = shuffle(users.concat(userPairs));
                        this.setState({ cards: deck });
                        return [2 /*return*/];
                }
            });
        });
    };
    BoardyMemoryGame.prototype.render = function () {
        var _this = this;
        var _a = this.state, cards = _a.cards, revealedCards = _a.revealedCards, selectedCards = _a.selectedCards;
        var cardElements = cards.map(function (i) { return React.createElement(MemoryCardSlot, { key: i.id, card: i, selectedCards: selectedCards, revealedCards: revealedCards, onSelect: _this.handleCardSelection }); });
        return (React.createElement("section", { style: styles.gameContainer }, cardElements));
    };
    BoardyMemoryGame = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], BoardyMemoryGame);
    return BoardyMemoryGame;
}(React.Component));
export default BoardyMemoryGame;



//////////////////
// WEBPACK FOOTER
// ./src/components/BoardyMemoryGame.tsx
// module id = 804
// module chunks = 0